import React, {Component} from 'react';
import districtJson from '../utils/district.json';
import Dialog from '../components/dialog';
import { isWeChat,regExpression } from '../utils/util';
import { get } from '../utils/request';

class Name extends Component  {
  static defaultProps = {
    name: ''
  }
  handleChange = (e) => {
    const [key, value] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render() {
    const showErr = this.props.checkErr && !!!this.props.name;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">姓名：</label>
        <input
          type="text"
          className={classShowName}
          name="name"
          value={this.props.name}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">请填写姓名</span> }
      </div>
    )
  }
}

class Phone extends Component  {
  static defaultProps = {
    phone: ''
  }
  constructor(props) {
    super(props);
    this.state = {
      isShowDialog: false
    }
  }
  showSureDialog = () => {
    this.setState({
      isShowDialog: true
    })
  }
  confirmChangePhone = () => {
    this.setState({
      isShowDialog: false
    })
    // 退出当前账户，重新恢复未登录状态
    get('/api/website/user/logout/')
    .then(res => {
      if (res.code === 200) {
        window.location.reload();
      }
    })
  }
  render() {
    return (
      <div className="info-item">
        <label className="s-label">手机：</label>
        <input
          type="text"
          className="s-input s-input-disabled"
          name="phone"
          value={this.props.phone}
          disabled="disabled"
        />
        { !isWeChat() && <span className="change-phone" onClick={this.showSureDialog}>更换手机号</span> }
        <Dialog isShow={this.state.isShowDialog}>
          <div className="wrapper-content sure-change-phone">
            <div className="title">确定是否要更换手机号</div>
            <div className="button">
              <span onClick={this.confirmChangePhone}>确定</span>
              <span onClick={() => {
                this.setState({
                  isShowDialog: false
                })
              }}>取消</span>
            </div>
          </div>
        </Dialog>
      </div>
    )
  }
}

class Sex extends Component  {
  static defaultProps = {
    sex: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render() {
    const showErr = this.props.checkErr && !!!this.props.sex;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-select ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">性别：</label>
        <select className={classShowName} name="sex" value={this.props.sex} onChange={this.handleChange}>
          <option value="">请选择</option>
          <option value="男">男</option>
          <option value="女">女</option>
        </select>
        { showErr && <span className="err-tips">请选择性别</span> }
      </div>
    )
  }
}

class Wechat extends Component {
  static defaultProps = {
    wechat: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.wechat;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">微信：</label>
        <input
          type="text"
          className={classShowName}
          name="wechat"
          value={this.props.wechat}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">请填写微信</span> }
      </div>
    )
  }
}

class Email extends Component {
  static defaultProps = {
    email: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!regExpression().emailReg.test(this.props.email);
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">邮箱：</label>
        <input
          type="text"
          className={classShowName}
          name="email"
          value={this.props.email}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">请填写正确的邮箱</span> }
      </div>
    )
  }
}

class Position extends Component {
  static defaultProps = {
    position: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.position;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">职位：</label>
        <input
          type="text"
          className={classShowName}
          name="position"
          value={this.props.position}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">请填写职位</span> }
      </div>
    )
  }
}

class Company extends Component {
  static defaultProps = {
    company_name: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.company_name;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">公司：</label>
        <input
          type="text"
          className={classShowName}
          name="company_name"
          value={this.props.company_name}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">请填写公司</span> }
      </div>
    )
  }
}

class Province extends Component {
  static defaultProps = {
    province: ''
  }
  constructor(props) {
    super(props);
    this.state = {...props};
  }
  handleChange = (event) => {
    this.setState({
      province: event.target.value
    })
    this.props.returnData({province: event.target.value});
  }
  render() {
    return (
      <select className={this.props.classReName} value={this.state.province} onChange={this.handleChange}>
        <option value="">请选择</option>
        {
          districtJson.province.map((val) => {
            return <option key={val.toString()} value={val}>{val}</option>
          })
        }
      </select>
    )
  }
}

class District extends Component {
  static defaultProps = {
    district: '',
    province: ''
  }
  handleChange = (event) => {
    this.setState({
      district: event.target.value
    })
    this.props.returnData({district: event.target.value});
  }
  render() {
    this.state = {...this.props};
    const classShowName = `${this.props.classReName} right`;
    return (
      <select className={classShowName} value={this.state.district} onChange={this.handleChange}>
        <option value="">请选择</option>
        { this.props.province &&
          districtJson.city[this.props.province].map((val) => {
            return <option key={val.toString()} value={val}>{val}</option>
          })
        }
      </select>
    )
  }
}

class ProvinceDistrict extends Component {
  static defaultProps = {
    province: '',
    district: ''
  }
  constructor(props) {
    super(props);
    this.state = {...props};
  }
  handleData = (resJson) => {
    const returnBack = () => {
      // 回传值
      this.props.onValueChange({
        province: resJson.hasOwnProperty("province") ? resJson['province'] : this.state.province,
        district: resJson['district'] ? resJson['district'] : ''
      })
    }

    // 设置province值
    resJson.hasOwnProperty("province") && this.setState({
      province: resJson['province'],
      district: ''
    }, returnBack)

    // 设置district值
    resJson.hasOwnProperty("district") && this.setState({
      district: resJson['district']
    }, returnBack)

  }
  showErr = (province, district) => {
    if (this.props.checkErr && (!!!province || !!!district)) {
      return <span className="err-tips">请选择地域</span>
    }
    return null;
  }
  render() {
    const showErrProvince = this.props.checkErr && !!!this.state.province;
    const showErrDistrict = this.props.checkErr && !!!this.state.district;
    const errP = showErrProvince ? 'err-s' : '';
    const errD = showErrDistrict ? 'err-s' : '';
    const classShowProName = `s-select ${errP}`;
    const classShowDisName = `s-select ${errD}`;
    return (
      <div className="info-item">
        <label className="s-label">城市：</label>
        <Province province={this.state.province} returnData={this.handleData} classReName={classShowProName}/>
        <District province={this.state.province} district={this.state.district} returnData={this.handleData} classReName={classShowDisName}/>
        {this.showErr(this.state.province, this.state.district)}
      </div>
    )
  }
}

class IntroSelf extends Component {
  static defaultProps = {
    intro: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.intro;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-textarea ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">自我介绍：</label>
        <textarea
          className={classShowName}
          name="intro"
          value={this.props.intro}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">请填写自我介绍</span> }
      </div>
    )
  }
}

class ChooseSignClass extends Component {
  static defaultProps = {
    nearestLesson: []
  }
  constructor(props) {
    super(props);
    this.state = {...props};
    this.state.lesson_id = props.nearestLesson.length && props.nearestLesson[0].id;
  }
  componentDidMount() {
    this.props.onValueChange({
      lesson_id: this.state.lesson_id
    })
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.setState({
      [key]: value
    })
    this.props.onValueChange({
      [key]: value
    })
  }
  render() {
    return (
      <div className="info-item">
        <label className="s-label">报名课堂：</label>
        <select className="s-select" name="lesson_id" value={this.state.lesson_id} onChange={this.handleChange}>
          {
            this.props.nearestLesson.map((val) => {
              let dateShow = "";
              if (val.date && val.date.indexOf('-') > -1) {
                const dateArray = val.date.split('-');
                dateShow = `${dateArray[0]}月${dateArray[1]}日`
              }
              return <option key={val.name.toString()} value={val.id}>{val.name}({dateShow} {val.city})</option>
            })
          }
        </select>
      </div>
    )
  }
}

// class 页面
class UserInfoClass extends Component {
  constructor (props) {
    super(props);
    this.state = { ...this.props };
    this.isRight = true;
    this.debug = false
  }
  handleValueChange = (resObj) => {
    for(let index in resObj){
      if (typeof(resObj[index]) === 'string') {
        resObj[index] = resObj[index].replace(/^\s*/g,"");
      }
    }
    this.setState({
      ...resObj
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData(this.state);
    });
  }
  validateFunction = () => {
    let flag = true;
    const validateMap = new Map();
    // validateMap.set('classValidate', ['name', 'wechat', 'sex', 'email', 'province', 'district']);
    validateMap.set('classValidate', ['name', 'wechat', 'email', 'province', 'district']);
    for (let i in this.state) {
      if (validateMap.get('classValidate').indexOf(i) > -1 && !this.state[i]) {
        flag = false;
      }
      // 处理邮箱校验
      if (i === 'email' && validateMap.get('classValidate').indexOf(i) > -1 && !regExpression().emailReg.test(this.state[i])) {
        flag = false;
      }
    }
    return flag;
  }
  componentDidMount () {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }
  render () {
    const districtProvince = {
      province: this.state.province ? this.state.province : '',
      district: this.state.district ? this.state.district : '',
    }
    return (
      <div className="user-info border-bottom padding-bottom-30">
        <p className="s-title">个人信息</p>
        { this.debug &&
          <div>
            <p> user info props: </p>
            <p> {JSON.stringify(this.state,null,2) }</p>
          </div>
        }
        {/* 只有创业课堂有这个问题 */}
        {
          this.props.class_type === '创业课堂' &&
          <ChooseSignClass
            nearestLesson={this.props.nearestLesson}
            onValueChange={this.handleValueChange}
          />
        }
        <Name
          name={this.state.name}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        {
          this.state.class_type != '卓见沙龙' &&
          <Sex
            sex={this.state.sex}
            checkErr= {this.props.checkErr}
            onValueChange={this.handleValueChange}
          />
        }
        <Phone
          phone={this.state.phone}
          receiveLogoutData={this.props.receiveLogoutData}
        />
        <Wechat
          wechat={this.state.wechat}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Email
          email={this.state.email}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <ProvinceDistrict
          { ...districtProvince }
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
      </div>
    )
  }
}

// class 页面
class UserInfoFa extends Component {
  constructor (props) {
    super(props);
    this.state = { ...this.props };
    this.isRight = true;
  }
  handleValueChange = (resObj) => {
    for(let index in resObj){
      if (typeof(resObj[index]) === 'string') {
        resObj[index] = resObj[index].replace(/^\s*/g,"");
      }
    }
    this.setState({
      ...resObj
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData(this.state);
    });
  }
  validateFunction = () => {
    let flag = true;
    const validateMap = new Map();
    validateMap.set('classValidate', ['name', 'wechat', 'email', 'province', 'district']);
    for (let i in this.state) {
      if (validateMap.get('classValidate').indexOf(i) > -1 && !this.state[i]) {
        flag = false;
      }
      // 处理邮箱校验
      if (i === 'email' && validateMap.get('classValidate').indexOf(i) > -1 && !regExpression().emailReg.test(this.state[i])) {
        flag = false;
      }
    }
    return flag;
  }
  componentDidMount () {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }
  render () {
    const districtProvince = {
      province: this.state.province ? this.state.province : '',
      district: this.state.district ? this.state.district : '',
    }
    return (
      <div className="user-info border-bottom padding-bottom-30">
        <p className="s-title">个人信息</p>
        {/* 只有创业课堂有这个问题 */}
        {
          this.props.class_type === '创业课堂' &&
          <ChooseSignClass
            nearestLesson={this.props.nearestLesson}
            onValueChange={this.handleValueChange}
          />
        }
        <Name
          name={this.state.name}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Phone
          phone={this.state.phone}
          receiveLogoutData={this.props.receiveLogoutData}
        />
        <Wechat
          wechat={this.state.wechat}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Email
          email={this.state.email}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <ProvinceDistrict
          { ...districtProvince }
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
      </div>
    )
  }
}


// 游学课堂
class UserInfoExpo extends Component {
  constructor (props) {
    super(props);
    this.state = {...props};
    this.isRight = true;
  }
  handleValueChange = (resObj) => {
    for(let index in resObj){
      if (typeof(resObj[index]) === 'string') {
        resObj[index] = resObj[index].replace(/^\s*/g,"");
      }
    }
    this.setState({
      ...resObj
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData(this.state);
    });
  }
  validateFunction = () => {
    let flag = true;
    const validateMap = new Map();
    // validateMap.set('expoValidate', ['name', 'wechat', 'sex', 'email', 'company_name', 'position']);
    validateMap.set('expoValidate', ['name', 'wechat', 'email', 'company_name', 'position']);
    for (let i in this.state) {
      if (validateMap.get('expoValidate').indexOf(i) > -1 && !this.state[i]) {
        flag = false;
      }
      // 处理邮箱校验
      if (i === 'email' && validateMap.get('expoValidate').indexOf(i) > -1 && !regExpression().emailReg.test(this.state[i])) {
        flag = false;
      }
    }
    return flag;
  }
  componentDidMount () {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }
  render () {
    return (
      <div className="user-info">
        <Name
          name={this.state.name}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Phone
          phone={this.state.phone}
        />
        <Wechat
          wechat={this.state.wechat}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Email
          email={this.state.email}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Sex
          sex={this.state.sex}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Company
          company_name={this.state.company_name}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Position
          position={this.state.position}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
      </div>
    )
  }
}

// 大会报名页面
class UserInfoCon extends Component {
  constructor (props) {
    super(props);
    this.state = {...props};
    this.isRight = true;
  }
  handleValueChange = (resObj) => {
    for(let index in resObj){
      if (typeof(resObj[index]) === 'string') {
        resObj[index] = resObj[index].replace(/^\s*/g,"");
      }
    }
    this.setState({
      ...resObj
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData(this.state);
    });
  }
  validateFunction = () => {
    let flag = true;
    const validateMap = new Map();
    validateMap.set('conValidate', ['name']);
    for (let i in this.state) {
      if (validateMap.get('conValidate').indexOf(i) > -1 && !this.state[i]) {
        flag = false;
      }
    }
    return flag;
  }
  componentDidMount () {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }
  render () {
    return (
      <div className="user-info margin-top-30">
        <p className="s-title">填写信息</p>
        <Name
          name={this.state.name}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Phone
          phone={this.state.phone}
        />
      </div>
    )
  }
}

// 媒体简介
class UserInfoMedia extends Component {
  constructor (props) {
    super(props);
    this.state = {...props};
    this.isRight = true;
  }
  handleValueChange = (resObj) => {
    for(let index in resObj){
      if (typeof(resObj[index]) === 'string') {
        resObj[index] = resObj[index].replace(/^\s*/g,"");
      }
    }
    this.setState({
      ...resObj
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData(this.state);
    });
  }
  validateFunction = () => {
    let flag = true;
    const validateMap = new Map();
    validateMap.set('mediaValidate', ['name', 'email', 'position', 'wechat']);
    for (let i in this.state) {
      if (validateMap.get('mediaValidate').indexOf(i) > -1 && !this.state[i]) {
        flag = false;
      }
      // 处理邮箱校验
      if (i === 'email' && validateMap.get('mediaValidate').indexOf(i) > -1 && !regExpression().emailReg.test(this.state[i])) {
        flag = false;
      }
    }
    return flag;
  }
  componentDidMount () {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }
  render () {
    return (
      <div className="user-info margin-top-30 padding-top-30 padding-bottom-30">
        <p className="s-title">个人信息</p>
        <Name
          name={this.state.name}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Phone
          phone={this.state.phone}
        />
        <Wechat
          wechat={this.state.wechat}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Email
          email={this.state.email}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Position
          position={this.state.position}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
      </div>
    )
  }
}

export {
  UserInfoFa,
  UserInfoClass,
  UserInfoExpo,
  UserInfoCon,
  UserInfoMedia
}
